import * as React from 'react';

const sizeToScale = {
  small: 0.2,
  medium: 0.5,
};

type Props = {
  size?: 'small' | 'medium';
};

const Loading = (props: Props) => {
  const size = props.size || 'small';
  const scale = sizeToScale[size];
  const pixels = `${80 * scale}px`;

  return (
    <div className="flex h-full justify-center">
      <div style={{width: pixels, height: pixels, margin: 'auto'}}>
        <div
          className="relative inline-block h-20 w-20 origin-top-left"
          style={{transform: `scale(${scale})`}}
        >
          <div
            className="border-muted-foreground absolute box-border block h-16 w-16 rounded-full border-8 border-transparent border-t-current m-2"
            style={{animation: 'loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite', animationDelay: '-0.45s'}}
          />
          <div
            className="border-muted-foreground absolute box-border block h-16 w-16 rounded-full border-8 border-transparent border-t-current m-2"
            style={{animation: 'loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite', animationDelay: '-0.3s'}}
          />
          <div
            className="border-muted-foreground absolute box-border block h-16 w-16 rounded-full border-8 border-transparent border-t-current m-2"
            style={{animation: 'loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite', animationDelay: '-0.15s'}}
          />
          <div
            className="border-muted-foreground absolute box-border block h-16 w-16 rounded-full border-8 border-transparent border-t-current m-2"
            style={{animation: 'loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite'}}
          />
        </div>
      </div>
    </div>
  );
};

export default Loading;
